module.exports = __webpack_public_path__ + "img/confianza.4e7d7b8c.png";